import React, { createContext, useState, useEffect, useContext } from 'react';
import { login as apiLogin, register as apiRegister, getUserProfile } from '../services/api';

// Create the auth context
const AuthContext = createContext();

// Custom hook to use the auth context
export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  async function login(email, password) {
    try {
      const data = await apiLogin(email, password);
      localStorage.setItem('token', data.access_token);
      
      // Obține profilul utilizatorului
      try {
        const userProfile = await getUserProfile();
        localStorage.setItem('user', JSON.stringify(userProfile));
        setCurrentUser(userProfile);
        return userProfile;
      } catch (profileError) {
        // Dacă nu putem obține profilul, folosim un minim de informații
        const basicUser = { email };
        localStorage.setItem('user', JSON.stringify(basicUser));
        setCurrentUser(basicUser);
        return basicUser;
      }
    } catch (error) {
      throw new Error(error.response?.data?.detail || 'Autentificare eșuată');
    }
  }

  async function register(email, password) {
    try {
      await apiRegister(email, password);
      return login(email, password);
    } catch (error) {
      throw new Error(error.response?.data?.detail || 'Înregistrare eșuată');
    }
  }

  function logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setCurrentUser(null);
    return Promise.resolve();
  }

  // Check for existing user session
  useEffect(() => {
    const checkSession = async () => {
      const token = localStorage.getItem('token');
      const userStr = localStorage.getItem('user');
      
      if (token && userStr) {
        try {
          // Verifică dacă token-ul este încă valid încercând să obțină profilul
          const userProfile = await getUserProfile();
          setCurrentUser(userProfile);
        } catch (error) {
          // Dacă token-ul nu mai este valid, folosește datele din localStorage
          try {
            setCurrentUser(JSON.parse(userStr));
          } catch (e) {
            // Dacă și datele din localStorage sunt corupte, resetăm tot
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            setCurrentUser(null);
          }
        }
      }
      
      setLoading(false);
    };
    
    checkSession();
  }, []);

  const value = {
    currentUser,
    login,
    register,
    logout
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}